module.exports = __webpack_public_path__ + "src/styles/fonts/monologue-rounded.otf";